import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import React, {Component} from 'react';
import {Alert, Col, Row} from 'react-bootstrap';
import {Bar} from 'react-chartjs-2';
import utilManagement from '../../../../../../apis/utilManagement';
//import {connect} from 'react-redux';
//import {cekCookies} from '../../../../../actions';
import {CONFIG_UTIL} from '../../../../../../config';
import Loader from '../../../../../Loader';

import LoaderModal from '../../../../../modal/LoaderModal';


import './report.css';


class ReportSiswa extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            isFetching : false,
            alertShow: false,
            resMessage: "message",
            tahunAjaran : [],
            provinsi: [],
            kota: [],
            sekolah: [],
            idProvinsi : null,
            idKota : null,
            idSekolah : null,
            namaSekolahSearch : null,
            taAktif : null,
            siswa : '',
            kategoriMapelLit: '',
            deskripsiMapelLit: '',
            kategoriMapelNum: '',
            deskripsiMapelNum: '',
            dataInfo: {},
            dataMapel: [],
            detailAkademik: [],
            dataIndikator: [],
            dataSK: [],
            dataSLB: [],
            dataIndekSosial: []
        }
    }

    async componentDidMount() { 
        //await this.props.cekCookies();
        //if(!__.isEmpty(this.props.account)) {
            this.fetchReport();
        //}
    }

    fetchReport = async() => {   
        this.setState({isFetching:true })     
        const patch = this.props.match.params.idSiswa+'/'+
                        this.props.match.params.idJadwal+'/'+
                        this.props.match.params.idSekolah+'/'+
                        this.props.match.params.idKelas+'/'+
                        this.props.match.params.idKelasParalel;

        const response = await utilManagement.get(CONFIG_UTIL.REPORT_SISWA_AKM + patch, {})
        if(response){
            if(response.data){
                document.title = response.data.siswa + ' - '+ response.data.kelas;
                this.setState({ 
                    dataInfo: response.data,
                    dataMapel: response.data.dataMapel,
                    detailAkademik: response.data.detailAkademik,
                    dataIndikator: response.data.dataIndikator,
                    dataSK: response.data.dataNonAkademik.SK === undefined ? [] : response.data.dataNonAkademik.SK,
                    dataSLB: response.data.dataNonAkademik.SLB === undefined ? [] : response.data.dataNonAkademik.SLB                    
                });

                response.data.dataMapel.map(item => {
                    let nama = item.namaMataPelajaran
                    if('LITERASI' === nama){
                        let kategori = item.kategori.nama;
                        let deskripsi = item.kategori.deskripsi;
                        this.setState({
                            kategoriMapelLit: kategori,
                            deskripsiMapelLit: deskripsi
                        });
                    }
                    if('NUMERASI' === nama){
                        let kategori = item.kategori.nama;
                        let deskripsi = item.kategori.deskripsi;
                        this.setState({
                            kategoriMapelNum: kategori,
                            deskripsiMapelNum: deskripsi
                        });
                    }
                })

            } 
            this.setState({isFetching:false})
        }        
    } 

    renderDetailAkademik (mapel){
        const {detailAkademik} = this.state;
        return(
            detailAkademik.map((val, i)=>
                val.namaMapel == mapel &&
                    <td  style={{textAlign: 'center'}}>{val.jumlahBenar}</td>
                
            )
        )
    }

    renderKategoriAkademik (mapel){
        const {dataMapel} = this.state;
        return(
            dataMapel.map((val, i)=>
                val.namaMataPelajaran == mapel &&
                <>
                    <td  style={{textAlign: 'center'}}>{val.jmlBenar}</td>
                    <td  style={{textAlign: 'center'}}>{val.kategori.nama}</td>
                </>
            )
        )
    }


    render(){
        const {siswa, dataInfo, dataMapel, dataIndikator,dataSK, dataSLB, dataIndekSosial} = this.state;
        return(
            <div className="container-fluid" style={{paddingBottom: '50px', marginTop: '10px'}}>
                <LoaderModal isFetching={this.state.isFetching}/> 
                {this.loadAlert()}
                <Row>
                    <Col>
                        <div className="header-title-1">
                            STUDENT REPORT
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="header-title-2">
                            SIMULASI ASESMEN NASIONAL – EDUPRIME
                        </div>
                    </Col>
                </Row>
                <br></br>

                {/* =========== BIODATA  ========== */}
                <Row>
                    <Col>
                        <div className="biodata-kiri">
                            Nama : {dataInfo.siswa}
                        </div>
                    </Col>
                    <Col>
                        <div className="biodata-kiri">
                            Sekolah : {dataInfo.sekolah}
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="biodata-kiri">
                        Kelas : {dataInfo.kelas}
                        </div>
                    </Col>
                    <Col>
                        <div className="biodata-kiri">
                            Tgl. Test : {dataInfo.tanggal} 
                        </div>
                    </Col>
                </Row>
                <br></br>
                <hr />

                {/* ===================== AKM ======================== */}
                <Row>
                    <Col>
                        <div className="judul-akm ">
                            ASESMEN KOMPETENSI MINIMUM
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={2}>&nbsp;</Col>
                    <Col sm={3}>
                        {this.renderChart('LITERASI')}
                    </Col>
                    <Col sm={2}>&nbsp;</Col>
                    <Col sm={3}>
                        {this.renderChart('NUMERASI')}
                    </Col>
                    <Col sm={2}>&nbsp;</Col>
                    {/* <Col sm={5}>
                        <br />
                        <table width="100%" border="1">
                            <thead>
                                <tr>
                                    <th className="text-center">Subtes</th>
                                    <th className="text-center">Soal Benar</th>
                                    <th className="text-center">Rata Kelas</th>
                                    <th className="text-center">Rata Sekolah</th>
                                    <th className="text-center">Kategori</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dataMapel.map((sub,i)=>
                                        <tr key={i}>
                                            <td className="text-center">{sub.namaMataPelajaran}</td>    
                                            <td className="text-center">{sub.jmlBenar}</td>    
                                            <td className="text-center">{sub.rataKelas}</td>    
                                            <td className="text-center">{sub.rataSekolah}</td>
                                            <td className="text-center">{sub.kategori.nama}</td>            
                                        </tr>
                                    )
                                }
                                <tr>
                                    <td colSpan="2"  className="text-center">Rata - rata</td>
                                    <td  className="text-center">{dataInfo.rataKelas}</td>
                                    <td  className="text-center">{dataInfo.rataSekolah}</td>    
                                    <td  className="text-center">&nbsp;</td>                                    
                                </tr>
                            </tbody>
                        </table>
                    </Col> */}
                </Row>
                <Row>
                    <Col sm={12}>
                       <table className="table table-hover">
                           <thead>
                                <tr>
                                    <th rowSpan="2" width="5%">No.</th>
                                    <th rowSpan="2" width="20%">Nama Mata Pelajaran</th>
                                    <th colSpan="3" className="text-center">Jumlah Benar</th>
                                    <th rowSpan="2" width="10%" className="text-center">Total Benar</th>
                                    <th rowSpan="2" width="15%" className="text-center">Kategori</th>
                                </tr>
                                <tr>
                                    <th className="text-center">Level 1</th>
                                    <th className="text-center">Level 2</th>
                                    <th className="text-center">Level 3</th>
                                </tr>
                           </thead>
                           <tbody>
                               {
                                    dataMapel.map((sub,i)=>
                                    <tr key={i}>
                                        <td>{i+1}</td>  
                                        <td>{sub.namaMataPelajaran}</td>  
                                        {this.renderDetailAkademik(sub.namaMataPelajaran)}   
                                        <td className="text-center">{sub.jmlBenar}</td>
                                        <td className="text-center">{sub.kategori.nama}</td>            
                                    </tr>
                               )
                               }
                               {/* <tr>
                                   <td>1</td>
                                   <td>LITERASI</td>
                                   {this.renderDetailAkademik('LITERASI')}
                                   {this.renderKategoriAkademik('LITERASI')}
                               </tr>
                               <tr>
                                   <td>2</td>
                                   <td>NUMERASI</td>
                                   {this.renderDetailAkademik('NUMERASI')}
                                   {this.renderKategoriAkademik('NUMERASI')}
                               </tr> */}
                           </tbody>
                       </table>
                    </Col>
                </Row>

                <hr className="garis"></hr>
                {/* <Row>
                    <Col>
                        <p style={{"text-align": "center"}}>Berdasarkan hasil pengerjaan Asesmen Kompetensi Minimum pada subtes <strong>LITERASI</strong> anda termasuk dalam kategori <strong>{this.state.kategoriMapelLit}, {this.state.deskripsiMapelLit}</strong>.</p>
                        <p style={{"text-align": "center"}}>Berdasarkan hasil pengerjaan Asesmen Kompetensi Minimum pada subtes <strong>NUMERASI</strong> anda termasuk dalam kategori <strong>{this.state.kategoriMapelNum}, {this.state.deskripsiMapelNum}</strong>.</p>
                        <br />
                        <p style={{"text-align": "center"}}>Secara umum, Berdasarkan hasil pengerjaan Asesmen Kompetensi Minimum anda termasuk dalam kategori</p>
                    </Col>
                </Row>
                <Row>
                    <Col style={{"text-align": "-webkit-center"}}>
                        <div className="judul-akm" style={{"width": "300px"}}>
                            {dataInfo.keteranganAsm}
                        </div>
                    </Col>
                </Row>
                <hr></hr> */}

                {/* =============================== ANALISIS PENCAPAIAN INDIKATOR ================================ */}
                <Row>
                    <Col style={{"text-align": "-webkit-center"}}>
                        <div className="judul-analisispencapaianindikator">
                            ANALISIS PENCAPAIAN INDIKATOR
                        </div>
                    </Col>
                </Row>
                {
                    dataIndikator.map((mapel, i) =>
                        <> 
                            <Row key={i+1}>
                                <Col><b>{mapel.namaMataPelajaran}</b></Col>
                            </Row>
                            <Row key={i+2}>
                                {/* <Col sm={5}>Grafik</Col> */}
                                <Col sm={12}>
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th style={{"padding": "0px", "width": "80%"}}>Indikator</th>
                                                <th className="text-center">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                mapel.indikator.map((dt, j)=>
                                                    <tr key={j}>
                                                        <td style={{"padding": "0px"}}>
                                                            {dt.namaIndikator}
                                                        </td>
                                                        <td className="text-center" style={{"padding": "0px", "text-align-last": "center"}}>
                                                            {
                                                                dt.tuntas ? <DoneAllIcon style={{"color": "green"}}/>:<CancelPresentationIcon style={{"color": "red"}}/>
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </>
                    )
                    
                }


                <hr className="garis"></hr>
                
                {/* ====================================== SK =============================== */}
                <Row>
                    <Col>
                        <div className="judul-sk ">
                            SURVEY KARAKTER
                        </div>
                    </Col>
                </Row>
                <div className="row" style={{"marginTop" : "10px"}}>
                    <div className="col-md-12">
                        <div className="row">
                        {/* == GRAFIK == */}
                            <div className="col-md-6">
                                {/* looping */}
                                {dataSK.map((data,i) => 
                                <>
                                <div className="row" key={i}>
                                    <div className="col-md-6">
                                        {data.aspek}
                                    </div>
                                    <div className="col-md-6">
                                        <div className="graph">
                                            <div className="bg-graph val-graph" style={{ width: data.skor + '%' }}></div>
                                        </div> 
                                    </div>
                                </div>
                                <hr className="divider"></hr>
                                </>
                               
                                )}  
                            </div>
                            
                            {/* == TABEL == */}
                            <div className="col-md-6">
                                <div className="row">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Profil Pelajar Pancasila</th>
                                                <th className="text-center">Skor</th>
                                                <th className="text-center">Kategori</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* diloop */}
                                            {dataSK.map((data,i) => 
                                            <tr key={i}>
                                                <td>{data.aspek}</td>
                                                <td className="text-center">{data.skor}</td>
                                                <td className="text-center">{data.kategori}</td>
                                            </tr>
                                            )} 
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>

                {/* ====================================== AHSK =============================== */}
                <Row>
                    <Col style={{"text-align": "-webkit-center"}}>
                        <div className="judul-hasilanalisissurveykarakter">
                            ANALISIS HASIL SURVEI KARAKTER
                        </div>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col style={{"text-align": "-webkit-center"}}>
                    <p style={{"text-align": "center"}}>
                        Berdasarkan hasil pengerjaan siswa terkait survei yang dilakukan oleh Eduprime (mengenai Survei Karakter
                        dengan tema Profil Pelajar Pancasila), diperoleh hasil sebagai berikut:</p>
                    </Col>
                </Row>
                <br />
                {dataSK.map((data,i) =>
                <Row key={i}>
                    <Col>
                            <div className="sub-heading2-ahsk">{data.aspek}</div>
                            <div className="sub-heading3-ahsk">
                                <p style={{"text-align": "center"}}>
                                    {data.deskripsi}
                                </p>
                            </div>
                            <br />
                    </Col>
                </Row>
                )}
                <div id="btn_print">
                    <div className="fixed_button">
                        <button className="btn btn-outline-primary btn133w pull-right" style={{marginRight:'1em'}} onClick={() => window.print()}>Print</button>
                    </div>                                    
                </div>
            </div>
        );
    }

    renderChart(mapel) {

        let title = mapel;
        let data = [];
        let label = ['Skor', 'Rata Kelas', 'Rata Sekolah'];

        this.state.dataMapel.map(item => {
            let nama = item.namaMataPelajaran
            if(mapel === nama){
                data.push(item.skor);
                data.push(item.rataKelas);
                data.push(item.rataSekolah);
            }
        })
        
        return(
            <>
                <Bar
                    data={{
                        labels: label,
                        datasets: [
                            {
                                label: title,
                                data: data,
                                backgroundColor: [
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 206, 86, 0.2)',
                                    'rgba(75, 192, 192, 0.2)'
                                ],
                                borderColor: [
                                    'rgba(255, 99, 132, 1)',
                                    'rgba(255, 206, 86, 1)',
                                    'rgba(75, 192, 192, 1)'
                                ],
                                borderWidth: 0
                            }
                        ]
                    }}
                    height="260px"
                    options = {{  
                        legend: {
                        },                      
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                },
                                gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                }
                            }],
                            xAxes: [{
                                gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                }
                            }],
                        }                        
                    }}
                />
                
            </>             
        )
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }
        
    loadAlert = () => {
        const {alertShow } = this.state;      
        if (alertShow) {
          return (
            <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }  

}
//const mapStateToProps = (state) => {
//    return{
//        account: state.account
//    };
//}

//export default connect(mapStateToProps, {cekCookies})(ReportAgcu);

export default ReportSiswa;